import { defineMessages } from "react-intl";

const baseId = "t.pages.DelegationManagement.";

export default defineMessages({
  pageTitle: {
    id: baseId + "pageTitle",
    defaultMessage: "DELEGATION MANAGEMENT",
  },
});
